import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { templateMdrCompaniesGrid } from '../../mdrCompaniesGrid/view/template';
import { MdrSecurityTelemetryExclusionsGridWebComponent } from '../component/MdrSecurityTelemetryExclusionsGridWebComponent';
import { MdrSecurityTelemetryExclusionsGridView } from '../view/MdrSecurityTelemetryExclusionsGridView';
import { MdrSecurityTelemetryExclusionsGridRepository } from '../repository/MdrSecurityTelemetryExclusionsGridRepository';
import { MdrSecurityTelemetryExclusionsWebComponentSchema } from '../types';

export class MdrSecurityTelemetryExclusionsGridController extends BaseWebComponentController {
  public component: MdrSecurityTelemetryExclusionsGridWebComponent;
  public dataRepository: MdrSecurityTelemetryExclusionsGridRepository;
  public view: MdrSecurityTelemetryExclusionsGridView;
  public viewConstructor: typeof MdrSecurityTelemetryExclusionsGridView;
  public dataRepositoryConstructor: typeof MdrSecurityTelemetryExclusionsGridRepository;

  constructor(component: MdrSecurityTelemetryExclusionsGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MdrSecurityTelemetryExclusionsGridView,
      viewTemplate: templateMdrCompaniesGrid,
      dataRepositoryConstructor: MdrSecurityTelemetryExclusionsGridRepository,
    });
  }

  async getDataForView(): Promise<MdrSecurityTelemetryExclusionsWebComponentSchema> {
    return this.dataRepository.getDataForView();
  }
}
